/**
 * Ryan O'Dowd
 * 2022-08-05
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({safeAreaInsets}) => {
  return {
    offlineBanner: {
      marginBottom: 8,
    },
    buttonGroupWrapper: {
      display: 'flex',
      margin: 16,
      marginTop: 0,
      marginBottom: 8,
    },
    list: {
      paddingBottom: safeAreaInsets.bottom + 4,
    },
  };
};

export default getStyles;
